import styled from "@emotion/styled";
import "@mondaydotcomorg/monday-ui-components/dist/Tag.css";
import { TABLET_QUERY_MIN_WIDTH } from "/constants/vp-sizes";
export const StyledTemplateHeader = styled.div`
  display: flex;

  .template-data-wrapper {
    display: flex;
    flex-direction: column;
    line-height: 30px;
    justify-content: center;

    .template-name {
      font-size: 1.375rem;
      font-weight: 700;
    }

    .template-details-wrapper {
      margin-top: 6px;

      .template-categories {
        display: flex;
        font-size: 0.8125rem;

        .categories-wrapper {
          display: flex;
          margin-left: 4px;

          .category-wrapper {
            display: flex;

            &:not(:last-child) {
              &::after {
                content: ",";
              }

              margin-right: 4px;
            }
          }
        }
      }
    }
  }

  @media (max-width: ${TABLET_QUERY_MIN_WIDTH}) {
    .template-data-wrapper {
      .template-details-wrapper {
        margin-top: 2px;
      }
    }
  }
`;
